import React, { useState, useEffect, useRef } from "react";
import { useCookies } from "react-cookie";
import DashboardAppointmentsViewFooter from "./DashboardAppointmentsViewFooter";
import DashboardAppointmentsViewHeader from "./DashboardAppointmentsViewHeader";
import DashboardAppointmentsViewTable from "./DashboardAppointmentsViewMainContent/DashboardAppointmentsViewTable";
import {
  getCapturedTime,
  getClinicDoctorList,
  getDashboardppointmentsData,
  getModifiedAppointmentsRes,
  getPaymentMethod,
  getRefreshedAppointmentData,
  getSlotDuration,
  getStaffDoctorList,
  getStatusForParamsFromUrl,
} from "./DashboardAppointmentsViewApiHandler";
import { useHistory, useLocation } from "react-router-dom";
import {
  addDashboardFilterLocalStorage,
  addQuery,
  getDashboardFilterFromLocalStorage,
  getProcedureAPIPayload,
  removeDashboardFilterFromLocalStorage,
  removeQuery,
} from "./Helper/index";
import {
  APIFILTERLIST,
  SELECTEDFILTERTITLE,
  APPLICABLE_ROLE,
  DEFAULT_DASHBOARD_PAYLOAD,
  STATUS_COUNT,
  PAYMENT_METHOD_HEADER,
  CONSULTATIONTYPE,
  STATUS_COUNT_QUEUE,
  DASHBOARD_VIEW,
  QUEUE_STATUS,
  PRESCRIPTION_KEYS,
  POLLING_DURATION_FOR_REFRESH_API,
} from "../DashboardAppointmentsView/Constant";
import {
  DOWNLOAD_TRANSACTIONS_REPORT_API,
  GET_ALL_APPOINTMENTS_API,
  GET_CHECKED_IN_APPOINTMENT_API,
  GET_UHID_LIST,
} from "./DashboardAppointmentsViewApiHandler/APIConstants";
import { useLiveQuery } from "dexie-react-hooks";
import dexie_db from "../common/dexieDB";
import moment from "moment";
import { CONSULTATION_TYPE_LIST } from "../common/Modules/CustomeSelect/constant";
import DownloadReport from "../DownloadReport/DownloadReport";
import { USER_ROLE, USER_TYPE } from "../../Util/constants";
import { connect, unsubscribeWebSocket } from "../../Util/webSocketHelper";
import DoctorListJoyRides from "../common/DoctorListJoyRide/DoctorListJoyRide";
import * as stepsData from "../common/DoctorListJoyRide/constant";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";
import { c2cGetApiHandler, c2cPostApiHandler } from "../../Util/c2cApiHandler";
import C2CLogger from "../../Util/Helper/C2CLogger";

const logger = new C2CLogger();

const DashboardAppointmentsView = (props) => {
  const prevClinicId = useRef();
  const { callNextAppointmentWidget, clinicDropDownStatus } = props;
  const userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  const doctorRole = localStorage.getItem(LOCALSTORAGEKEY.DOCTOR_ROLE);
  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);
  const staffId = localStorage.getItem(LOCALSTORAGEKEY.STAFF_ID);
  const clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const doctorClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.DOCTOR_CLINIC_ASSOCIATION
  );
  const prevSelectedDoctor = localStorage.getItem(
    LOCALSTORAGEKEY.PREVIOUS_SELECTED_DOCTORS
  );
  const showedQueueViewSuggestion = localStorage.getItem(
    "showedQueueSuggestion"
  );
  const token = localStorage.getItem("id_token");
  const selectedClinic = localStorage.getItem(
    LOCALSTORAGEKEY.SELECTED_CLINIC_DETAILS
  );

  const history = useHistory();
  const location = useLocation();
  const currentRef = useRef("");
  const downloadRef = useRef();
  const prevClinic = useRef(clinicId);
  const doctRef = useRef(prevSelectedDoctor);

  const consultation_filter = new URLSearchParams(location.search).get(
    APIFILTERLIST.CONSULTATION
  );
  const app_start_date = new URLSearchParams(location.search).get(
    APIFILTERLIST.STARTDATE
  )
    ? new URLSearchParams(location.search).get(APIFILTERLIST.STARTDATE)
    : DEFAULT_DASHBOARD_PAYLOAD.start_date;
  const status_filter = new URLSearchParams(location.search).get(
    APIFILTERLIST.STATUS
  );
  const doctor_name_filter = new URLSearchParams(location.search).get(
    APIFILTERLIST.DOCTORNAME
  );
  const prescriptionFilter = new URLSearchParams(location.search).get(
    APIFILTERLIST.PRESCRIPTION_FILTER
  );
  const search_string = new URLSearchParams(location.search).get(
    APIFILTERLIST.SEARCHSTRING
  );
  const consultation_type = new URLSearchParams(location.search).get(
    APIFILTERLIST.CONSULTATION_TYPE
  )
    ? new URLSearchParams(location.search).get(APIFILTERLIST.CONSULTATION_TYPE)
    : CONSULTATIONTYPE.INCLINIC;
  const page_no = new URLSearchParams(location.search).get(APIFILTERLIST.PAGENO)
    ? new URLSearchParams(location.search).get(APIFILTERLIST.PAGENO)
    : DEFAULT_DASHBOARD_PAYLOAD.page_no;
  const sortOrder = new URLSearchParams(location.search).get(
    APIFILTERLIST.SORTORDER
  )
    ? new URLSearchParams(location.search).get(APIFILTERLIST.SORTORDER)
    : DEFAULT_DASHBOARD_PAYLOAD.sort_order;

  const is_procedure = new URLSearchParams(location.search).get(
    APIFILTERLIST.IS_PROCEDURE
  );

  const CURRENT_DATE = moment().format("YYYY-MM-dd");
  const prevConsultationType = useRef(consultation_type);
  const [cookies] = useCookies(["cookie-name"]);
  const [selected_doctor, setSelectedDoctor] = useState([]);
  const [allClinicDoctors, setAllClinicDoctors] = useState([]);
  const [contentLoading, setContentLoading] = useState(true);
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [showMobileFilter, setShowMobileFilter] = useState(false);
  const [showDownloadMobileFilter, setShowDownloadMobileFilter] =
    useState(false);
  const [selectedDate, setSelectedDate] = useState();
  const [selected_consultation_type, setConsultationType] = useState(
    CONSULTATION_TYPE_LIST[0]
  );
  const [sort_order, setSortOrder] = useState();
  const [statusCountHeader, setStatusCountHeader] = useState([]);
  const [selectedStatusCard, setSelectedStatusCard] = useState();
  const [paymentMethodHeader, setPaymentMethodHeader] = useState([]);
  const [selectedPaymentMethod, setSelectedPaymentMethod] = useState();
  const [disableDownload, setDisableDownload] = useState(false);
  const [downloadReport, setDownloadReport] = useState([]);
  const [procedures, setProcedures] = useState([]);
  const [consultationWiseDoctors, setConsultationWiseDoctors] = useState([]);

  const [statusCountHeaderQueue, setStatusCountHeaderQueue] = useState([]);
  const [selectedQueueDoctor, setSelectedQueueDoctor] = useState("");
  const [viewType, setViewType] = useState();
  const [showJoyride, setShowJoyride] = useState(false);
  const [paymentMethodHeaderQueue, setPaymentMethodHeaderQueue] = useState([]);
  const [selectedStatusCardQueue, setSelectedStatusCardQueue] = useState();
  const [selectedPaymentMethodQueue, setSelectedPaymentMethodQueue] =
    useState();
  const [showMobileFilterQueue, setShowMobileFilterQueue] = useState(false);
  const [checkedInAppnt, setCheckedInAppnt] = useState([]);
  const [clinicWithDoctor, setClinicWithDoctor] = useState({
    clinicId: null,
    doctor_ids: [],
    callApi: false,
  });
  const [isUhidEnabled, setIsUhidEnabled] = useState(false);
  const [socketResponse, setSocketResponse] = useState(false);
  const [hasDownloadPermission, setHasDownloadPermission] = useState(false);
  const [appointmentList, setAppointmentList] = useState([]);
  const [ongoingRequest, setOngoingRequest] = useState(false);
  const [lastSync, setLastSync] = useState(
    moment().format("YYYY-MM-DD HH:mm:ss")
  );
  const timeoutRef = useRef(false);

  const list = useLiveQuery(
    async () =>
      dexie_db.appointment
        .where("clinic_id")
        .equals(
          clinicWithDoctor?.clinicId ? clinicWithDoctor?.clinicId : "default"
        )
        .toArray((app) => {
          if (viewType === DASHBOARD_VIEW.LIST) {
            if (app.length > 0) {
              app = app.map((data) => {
                if (
                  Object.keys(data).includes(app_start_date) &&
                  (!clinicWithDoctor?.clinicId ||
                    clinicId === clinicWithDoctor?.clinicId) // added clinic id condition for not to show previous selected clinic data om date and clinic change
                ) {
                  let newdata = Object.values(data[app_start_date].data).filter(
                    (data) =>
                      data?.patient_name
                        ?.toLowerCase()
                        .includes(
                          search_string ? search_string.toLowerCase() : ""
                        ) ||
                      data?.patient_phone_no.includes(
                        search_string ? search_string : ""
                      ) ||
                      data?.formatted_uhid
                        ?.toLowerCase()
                        .includes(
                          search_string ? search_string.toLowerCase() : ""
                        )
                  );
                  if (
                    clinicWithDoctor?.doctor_ids &&
                    (userType === APPLICABLE_ROLE.STAFF ||
                      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
                      doctorRole === USER_ROLE.RESOURCE_ADMIN)
                  ) {
                    newdata = newdata.filter((appnt) =>
                      clinicWithDoctor?.doctor_ids.includes(appnt.doctor_id)
                    );
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                  }
                  if (consultation_type) {
                    newdata = newdata.filter(
                      (data) =>
                        data.main_consultation_type === consultation_type
                    );
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                    setConsultationWiseDoctors(newdata);
                  }
                  if (doctor_name_filter) {
                    newdata = newdata.filter(
                      (data) => data.doctor_id === doctor_name_filter
                    );
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                  }
                  if (consultation_filter) {
                    newdata = newdata.filter(
                      (data) =>
                        data.consultation_type?.toLowerCase() ===
                          consultation_filter?.toLowerCase() ||
                        data.procedure_name?.toLowerCase() ===
                          consultation_filter?.toLowerCase() ||
                        (data.is_lims_booking &&
                          data.group_procedure_names?.filter(
                            (ele) =>
                              ele?.toLowerCase() ===
                              consultation_filter?.toLowerCase()
                          )?.length > 0)
                    );
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                  }
                  if (status_filter) {
                    newdata = newdata.filter(
                      (data) =>
                        data.appointment_status.toLowerCase() ===
                        status_filter.toLowerCase()
                    );
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                  }
                  if (prescriptionFilter || prescriptionFilter == "") {
                    if (prescriptionFilter !== PRESCRIPTION_KEYS.ALL) {
                      newdata = newdata.filter((data) => {
                        if (prescriptionFilter === PRESCRIPTION_KEYS.CREATED) {
                          // if prescription filter is "created", "edited" is also added along with "created"
                          return (
                            data.prescription_status ===
                              PRESCRIPTION_KEYS.CREATED ||
                            data.prescription_status ===
                              PRESCRIPTION_KEYS.EDITED
                          );
                        } else if (
                          prescriptionFilter ===
                          PRESCRIPTION_KEYS.LAB_PROCEDURES
                        ) {
                          return +data.account_type === 1;
                        } else if (
                          prescriptionFilter ===
                          PRESCRIPTION_KEYS.CLINIC_APPOINTMENTS
                        ) {
                          return +data.account_type === 0;
                        } else {
                          return (
                            data.prescription_status === prescriptionFilter
                          );
                        }
                      });
                    }
                    setStatusCount(newdata);
                    setPaymentCount(newdata);
                  }
                  if (selectedStatusCard) {
                    newdata = newdata.filter(
                      (data) =>
                        data.appointment_status.toLowerCase() ===
                          selectedStatusCard.toLowerCase() ||
                        selectedStatusCard === "total"
                    );
                    setPaymentCount(newdata);
                  }
                  if (selectedPaymentMethod) {
                    if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
                      newdata = newdata.filter(
                        (data) =>
                          data.appointment_payment_method ===
                            selectedPaymentMethod ||
                          selectedPaymentMethod === "all" ||
                          (selectedPaymentMethod === "partial" &&
                            data?.partial_payment_filter)
                      );
                    }
                  }

                  if (sort_order) {
                    if (sort_order === "patient_name_az") {
                      newdata.sort((a, b) => {
                        return a.patient_name.localeCompare(b.patient_name); //using String.prototype.localCompare()
                      });
                    } else if (sort_order === "patient_name_za") {
                      newdata.sort((a, b) => {
                        return b.patient_name.localeCompare(a.patient_name); //using String.prototype.localCompare()
                      });
                    } else if (sort_order === "least_recent_first") {
                      newdata.sort((a, b) => {
                        return a.appointment_date_and_time.localeCompare(
                          b.appointment_date_and_time
                        ); //using String.prototype.localCompare()
                      });
                    } else if (
                      !sort_order ||
                      sort_order === "most_recent_first"
                    ) {
                      newdata.sort((a, b) => {
                        return b.appointment_date_and_time.localeCompare(
                          a.appointment_date_and_time
                        ); //using String.prototype.localCompare()
                      });
                    }
                  }
                  let finalData = [],
                    pageNo = 1;
                  while (newdata.length > 0) {
                    let spliceData = newdata.splice(
                      0,
                      Number(DEFAULT_DASHBOARD_PAYLOAD.rows_per_page)
                    );
                    spliceData.forEach((sp) => (sp.pageNo = pageNo));
                    finalData.push(...spliceData);
                    pageNo += 1;
                  }

                  return finalData;
                } else {
                  setAppointmentList([]);
                  handleDefaultStatusAndPaymentCount();
                  if (clinicWithDoctor?.clinicId === clinicId) {
                    callApi();
                  }
                  return [];
                }
              });
            } else {
              setAppointmentList([]);
              handleDefaultStatusAndPaymentCount();
              if (clinicWithDoctor?.clinicId === clinicId) {
                callApi();
              }
              return [];
            }
            displaySelectedFilters();
            setAppointmentList(app[0]);
            setContentLoading(false);
            return app[0];
          }
          setContentLoading(false);
        }),
    [
      search_string,
      status_filter,
      selectedStatusCard,
      selectedPaymentMethod,
      consultation_type,
      sort_order,
      doctor_name_filter,
      app_start_date,
      consultation_filter,
      viewType,
      prescriptionFilter,
      clinicWithDoctor,
    ]
  );

  const appointmentListQueueView = useLiveQuery(
    async () =>
      dexie_db.appointment
        .where("clinic_id")
        .equals(clinicId ? clinicId : "default")
        .toArray((app) => {
          if (viewType === DASHBOARD_VIEW.QUEUE) {
            if (selectedQueueDoctor) {
              if (app.length > 0) {
                app = app.map((data) => {
                  if (Object.keys(data).includes(app_start_date)) {
                    let newdata = Object.values(
                      data[app_start_date].data
                    ).filter(
                      (data) =>
                        data?.patient_name
                          ?.toLowerCase()
                          .includes(
                            search_string ? search_string.toLowerCase() : ""
                          ) ||
                        data?.patient_phone_no.includes(
                          search_string ? search_string : ""
                        ) ||
                        data?.formatted_uhid
                          ?.toLowerCase()
                          .includes(
                            search_string ? search_string.toLowerCase() : ""
                          )
                    );
                    newdata = newdata.filter(
                      (data) =>
                        data.appointment_status.toLowerCase() !==
                          QUEUE_STATUS.COMPLETED &&
                        data.appointment_status.toLowerCase() !==
                          QUEUE_STATUS.CANCELLED &&
                        data.appointment_status.toLowerCase() !==
                          QUEUE_STATUS.NO_SHOW
                    );
                    if (selectedQueueDoctor) {
                      newdata = newdata.filter(
                        (data) => data.doctor_id === selectedQueueDoctor
                      );
                      setStatusCountQueue(newdata);
                      setPaymentCountQueue(newdata);
                    }
                    if (consultation_type) {
                      newdata = newdata.filter(
                        (data) =>
                          data.main_consultation_type === consultation_type
                      );
                      setStatusCountQueue(newdata);
                      setPaymentCountQueue(newdata);
                    }
                    if (prescriptionFilter || prescriptionFilter == "") {
                      if (prescriptionFilter !== PRESCRIPTION_KEYS.ALL)
                        newdata = newdata.filter((data) => {
                          if (
                            prescriptionFilter === PRESCRIPTION_KEYS.CREATED
                          ) {
                            return (
                              data.prescription_status ===
                                PRESCRIPTION_KEYS.CREATED ||
                              data.prescription_status ===
                                PRESCRIPTION_KEYS.EDITED
                            );
                          } else {
                            return (
                              data.prescription_status === prescriptionFilter
                            );
                          }
                        });
                      setStatusCountQueue(newdata);
                      setPaymentCountQueue(newdata);
                    }
                    if (selectedStatusCardQueue) {
                      newdata = newdata.filter(
                        (data) =>
                          data.appointment_status.toLowerCase() ===
                            selectedStatusCardQueue.toLowerCase() ||
                          selectedStatusCardQueue === "total"
                      );
                      setPaymentCountQueue(newdata);
                    }
                    if (selectedPaymentMethodQueue) {
                      if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
                        newdata = newdata.filter(
                          (data) =>
                            data.appointment_payment_method ===
                              selectedPaymentMethodQueue ||
                            selectedPaymentMethodQueue === "all" ||
                            (selectedPaymentMethodQueue === "partial" &&
                              data?.partial_payment_filter)
                        );
                      }
                    }
                    newdata?.length > 0 &&
                      newdata.sort((a, b) => {
                        return a?.rank - b?.rank;
                      });
                    let finalData = [],
                      pageNo = 1;
                    while (newdata.length > 0) {
                      let spliceData = newdata.splice(
                        0,
                        Number(DEFAULT_DASHBOARD_PAYLOAD.rows_per_page)
                      );
                      spliceData.forEach((sp) => (sp.pageNo = pageNo));
                      finalData.push(...spliceData);
                      pageNo += 1;
                    }

                    return finalData;
                  } else {
                    return [];
                  }
                });
              } else {
                return [];
              }
              displaySelectedFilters();
              setContentLoading(false);
              return app[0];
            } else {
              let list = STATUS_COUNT_QUEUE;
              list.forEach((da) => {
                if (!da?.disabled) {
                  da.count = 0;
                } else {
                  da.count = "-";
                }
              });
              let payment_list = PAYMENT_METHOD_HEADER;
              payment_list.forEach((li) => {
                li.count = 0;
              });
              setPaymentMethodHeaderQueue(payment_list);
              setStatusCountHeaderQueue(list);
              setContentLoading(false);
              return [];
            }
          }
        }),
    [
      search_string,
      clinicId,
      selectedStatusCardQueue,
      selectedPaymentMethodQueue,
      selectedQueueDoctor,
      viewType,
      prescriptionFilter,
      consultation_type,
    ]
  );

  useEffect(() => {
    if (
      localStorage.getItem("AppntDisableDownload") &&
      localStorage.getItem("AppntDisableDownload") === "true"
    ) {
      setDisableDownload(true);
    } else {
      setDisableDownload(false);
    }
    return () => {
      setDownloadReport([]);
      localStorage.removeItem("DownloadReportArr");
      unsubscribeWebSocket(
        clinicId,
        userId,
        clinicWithDoctor?.doctor_ids,
        userType
      );
    };
  }, []);

  useEffect(() => {
    if (userType === USER_TYPE.STAFF && !clinicId) {
      return () => {
        unsubscribeWebSocket(
          clinicId,
          userId,
          clinicWithDoctor?.doctor_ids,
          userType
        );
      };
    }
  }, [clinicWithDoctor?.doctor_ids]);

  useEffect(() => {
    connect(
      token,
      clinicWithDoctor?.clinicId,
      prevClinicId.current,
      userId,
      socketResponseCallback,
      clinicWithDoctor?.doctor_ids,
      userType
    );
    prevClinicId.current = clinicWithDoctor?.clinicId;
  }, [clinicWithDoctor?.clinicId, clinicWithDoctor?.doctor_ids]);

  useEffect(() => {
    if (prevClinic?.current !== clinicId) {
      prevClinic.current = clinicId;
      removeQuery(history, location, [
        APIFILTERLIST.PRESCRIPTION_FILTER,
        APIFILTERLIST.DOCTORNAME,
        APIFILTERLIST.DOCTOR_NAME,
        APIFILTERLIST.SEARCHSTRING,
      ]);
      handleDefaultURL();
      removeQueueData();
      !clinicId?.length &&
        selectedPaymentMethod === "partial" &&
        setSelectedPaymentMethod("all");
    } else {
      if (app_start_date && prevClinic?.current === clinicId) {
        handleRefreshURL();
      }
    }
  }, [clinicId, app_start_date]);

  useEffect(() => {
    if (clinicWithDoctor?.callApi) {
      if (app_start_date === moment().format("YYYY-MM-DD")) {
        handleRefreshedData();
      } else {
        APICall();
      }
    }
  }, [clinicWithDoctor?.doctor_ids]);

  useEffect(() => {
    handleStatusCard("total");
    handlePaymentMethod(PAYMENT_METHOD_HEADER[0]);
    handleStatusCardQueue("total");
    handlePaymentMethodQueue(PAYMENT_METHOD_HEADER[0]);
    if (consultation_type) {
      clearAllFilters();
    }
    if (prevConsultationType.current !== consultation_type) {
      prevConsultationType.current = consultation_type;
      removeQueueData();
    }
  }, [consultation_type]);

  useEffect(() => {
    handleStatusCard("total");
    handleStatusCardQueue("total");
    handlePaymentMethodQueue(PAYMENT_METHOD_HEADER[0]);

    if (app_start_date !== moment().format("YYYY-MM-DD")) {
      removeQueueData();
    }
  }, [clinicId, app_start_date]);

  useEffect(() => {
    if (!clinicId && userType === APPLICABLE_ROLE.DOCTOR) {
      setClinicWithDoctor({
        ...clinicWithDoctor,
        clinicId: null,
        doctor_ids: [],
        callApi: true,
      });
      if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
        getProcedures([]);
      }
    }
    let mainSelectedDoctor =
      prevSelectedDoctor &&
      prevSelectedDoctor !== "undefined" &&
      JSON.parse(prevSelectedDoctor);
    doctRef.current =
      prevSelectedDoctor && prevSelectedDoctor !== "undefined"
        ? prevSelectedDoctor
        : [];
    let selectedDoctorId = [];
    if (mainSelectedDoctor) {
      let index = mainSelectedDoctor.findIndex(
        (da) => da.clinic_id === clinicId
      );
      selectedDoctorId = mainSelectedDoctor[index]?.doctors?.map(
        (data) => data.doctor_id
      );
    }
    if (userType === APPLICABLE_ROLE.STAFF && !clinicId) {
      let payload = {
        "authorizer-principal-id": {
          user_type: 4,
          staff_id: staffId,
        },
        staff_id: staffId,
        search: "False",
        dr_name: "",
        dr_phone_no: "",
      };
      let auth = token ? token : cookies?.id_token;
      const staffDoctorList = getStaffDoctorList(payload, auth);
      staffDoctorList.then(([res, err]) => {
        let arr = [];
        let arr1 = [];
        let allDoctors = [];
        if (res) {
          res.forEach((data) => {
            allDoctors.push(data.doctor_id);
            if (selectedDoctorId?.includes(data.doctor_id)) {
              arr.push(data.doctor_id);
              arr1.push(data);
            }
          });
        }
        arr1.sort((a, b) => {
          const firstNameA = a.dr_first_name
            ? a.dr_first_name.trim()
            : "" + a.dr_middle_name
            ? " " + a.dr_middle_name.trim()
            : "" + a.dr_last_name
            ? " " + a.dr_last_name.trim()
            : "";
          const firstNameB = b.dr_first_name
            ? b.dr_first_name.trim()
            : "" + b.dr_middle_name
            ? " " + b.dr_middle_name.trim()
            : "" + b.dr_last_name
            ? " " + b.dr_last_name.trim()
            : "";

          return firstNameA.localeCompare(firstNameB);
        });
        setAllClinicDoctors(allDoctors);
        setSelectedDoctor(arr1);
        setSocketResponse(false);
        setClinicWithDoctor({
          clinicId: clinicId,
          doctor_ids: arr,
          callApi: true,
        });
        if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
          getProcedures(arr);
        }
      });
    } else if (
      clinicId &&
      doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
      doctorRole !== USER_ROLE.RESOURCE_CONSULTANT
    ) {
      let params = { clinic_id: clinicId };
      let auth = token ? token : cookies?.id_token;
      const clinicDoctorList = getClinicDoctorList(params, auth);
      clinicDoctorList.then(([res, err]) => {
        let arr = [];
        let arr1 = [];
        let allDoctors = [];
        if (res) {
          res.forEach((data) => {
            allDoctors.push(data.doctor_id);
            if (selectedDoctorId?.includes(data.doctor_id)) {
              arr.push(data.doctor_id);
              arr1.push(data);
            }
          });
        }
        arr1.sort((a, b) => {
          const firstNameA = a.doctor_first_name
            ? a.doctor_first_name.trim()
            : "" + a.doctor_middle_name
            ? " " + a.doctor_middle_name.trim()
            : "" + a.doctor_last_name
            ? " " + a.doctor_last_name.trim()
            : "";
          const firstNameB = b.doctor_first_name
            ? b.doctor_first_name.trim()
            : "" + b.doctor_middle_name
            ? " " + b.doctor_middle_name.trim()
            : "" + b.doctor_last_name
            ? " " + b.doctor_last_name.trim()
            : "";

          return firstNameA.localeCompare(firstNameB);
        });
        setAllClinicDoctors(allDoctors);
        setSelectedDoctor(arr1);
        setSocketResponse(false);
        setClinicWithDoctor({
          clinicId: clinicId,
          doctor_ids: arr,
          callApi: true,
        });
        if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
          getProcedures(arr);
        }
      });
    } else if (
      clinicId &&
      (doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
        doctorRole === USER_ROLE.RESOURCE_CONSULTANT)
    ) {
      setClinicWithDoctor({
        clinicId: clinicId,
        doctor_ids: [],
        callApi: true,
      });
      if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
        getProcedures([]);
      }
    }
  }, [clinicId, prevSelectedDoctor]);

  useEffect(() => {
    let dashboardView = localStorage.getItem("dashboardView");
    if (!dashboardView) {
      localStorage.setItem("dashboardView", DASHBOARD_VIEW.LIST);
      setViewType(DASHBOARD_VIEW.LIST);
    } else {
      setViewType(localStorage.getItem("dashboardView"));
      if (dashboardView == DASHBOARD_VIEW.QUEUE) {
        handleButtonGroup(DASHBOARD_VIEW.QUEUE);
      }
    }
  }, []);

  useEffect(() => {
    setContentLoading(true);
    setAppointmentList([]); // setting appointments list to [] on clinic change
    handleDefaultStatusAndPaymentCount(); // setting payment and statis count to 0
    if (clinicId) {
      getClinicUhidDetailsAPICall();
    }
    let selectedClinicDetails = selectedClinic
      ? JSON.parse(selectedClinic)
      : {};
    if (
      Object.keys(selectedClinicDetails)?.length > 0 &&
      Object.keys(selectedClinicDetails)?.includes("permission_set") &&
      userType === USER_TYPE.STAFF
    ) {
      let checkPermission = true;
      if (
        Object.keys(selectedClinicDetails?.permission_set)?.length > 0 &&
        Object.keys(selectedClinicDetails?.permission_set)?.includes(
          "appointmentreport"
        )
      ) {
        checkPermission =
          selectedClinicDetails?.permission_set?.appointmentreport[0] === 1 &&
          selectedClinicDetails?.permission_set?.appointmentreport[1] === 1;
      }
      setHasDownloadPermission(checkPermission);
    } else {
      setHasDownloadPermission(true);
    }
  }, [clinicId]);

  // <==

  // Helper methods ==>

  const socketResponseCallback = (res) => {
    if (res.data !== "null") {
      let data = JSON.parse(res.data);
      if (data?.id === "refresh") {
        if (
          (clinicId &&
            doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
            doctorRole !== USER_ROLE.RESOURCE_CONSULTANT) ||
          userType === APPLICABLE_ROLE.STAFF
        ) {
          let mainSelectedDoctor = JSON.parse(doctRef.current);
          let selectedDoctorId = [];
          if (mainSelectedDoctor) {
            let index = mainSelectedDoctor.findIndex(
              (da) => da.clinic_id === clinicId
            );
            selectedDoctorId = mainSelectedDoctor[index]?.doctors?.map(
              (data) => data
            );
          }
          let arr = [];
          let arr1 = [];
          if (selectedDoctorId) {
            selectedDoctorId.forEach((data) => {
              arr.push(data.doctor_id);
              arr1.push(data);
            });
          }
          setSocketResponse(true);
          setSelectedDoctor(arr1);
          setClinicWithDoctor({
            clinicId: clinicId,
            doctor_ids: arr,
            callApi: false,
          });
        }
        updateAppointmentDataOnRefresh(data);
      }
    }
  };

  const updateAppointmentDataOnRefresh = async (socketData) => {
    let dbAppointments = await dexie_db.appointment.get(
      clinicId ? clinicId : "default"
    );
    let socketAppId = socketData?.appointment_id;
    let date = moment().format("YYYY-MM-DD");
    let isCurrentDate = app_start_date === date;
    if (isCurrentDate && socketData?.action === "update") {
      let appointmentIds = Object.keys(dbAppointments[date]["data"]);
      if (appointmentIds?.includes(socketAppId)) {
        let updatedAppointmentData = {
          ...dbAppointments[date]["data"][socketAppId],
          ...socketData?.data,
        };
        dbAppointments[date]["data"][socketAppId] = {
          ...updatedAppointmentData,
          captured_time: getCapturedTime(updatedAppointmentData),
          payment_method: getPaymentMethod(updatedAppointmentData),
          slot_duration: getSlotDuration(updatedAppointmentData),
        };

        dexie_db.appointment.put(dbAppointments);
      }
    } else if (isCurrentDate && socketData?.action === "delete") {
      let appointmentIds = Object.keys(dbAppointments[date]["data"]);
      if (appointmentIds?.includes(socketAppId)) {
        delete dbAppointments[date]["data"][socketAppId];
        dexie_db.appointment.put(dbAppointments);
      } else {
        handlePageRefresh(dbAppointments[date]?.last_sync);
      }
    } else if (
      isCurrentDate &&
      socketData?.action === "add" &&
      socketData?.data?.length
    ) {
      if (
        doctorRole === USER_ROLE.DOCTOR_CONSULTANT ||
        doctorRole === USER_ROLE.RESOURCE_CONSULTANT
      ) {
        if (socketData?.data[0]?.doctor_id === userId) {
          addAppointmentsDataOnRefresh(socketData, dbAppointments, date);
        }
      } else {
        addAppointmentsDataOnRefresh(socketData, dbAppointments, date);
      }
    }

    setLastSync(dbAppointments[date]?.last_sync);
    handlePageRefresh(dbAppointments[date]?.last_sync);
  };

  const addAppointmentsDataOnRefresh = (socketData, dbAppointments, date) => {
    let modifiedList = getModifiedAppointmentsRes(socketData?.data);
    let object = modifiedList?.reduce(
      (obj, item) => Object.assign(obj, { [item.appointment_id]: item }),
      {}
    );
    dbAppointments[date] = {
      ...dbAppointments[date],
      data: {
        ...dbAppointments[date].data,
        ...object,
      },
    };
    dexie_db.appointment.put(dbAppointments);
  };

  const handleDefaultURL = () => {
    addQuery(
      history,
      window.location,
      [
        APIFILTERLIST.CONSULTATION_TYPE,
        APIFILTERLIST.STARTDATE,
        APIFILTERLIST.SORTORDER,
        APIFILTERLIST.PAGENO,
      ],
      [
        CONSULTATIONTYPE.INCLINIC,
        DEFAULT_DASHBOARD_PAYLOAD.start_date,
        DEFAULT_DASHBOARD_PAYLOAD.sort_order,
        DEFAULT_DASHBOARD_PAYLOAD.page_no,
      ]
    );
    let consultVal = CONSULTATION_TYPE_LIST.filter(
      (data) => data.value === consultation_type
    );
    setConsultationType(consultVal[0]);
    setSelectedDate(DEFAULT_DASHBOARD_PAYLOAD.start_date);
    setSortOrder(DEFAULT_DASHBOARD_PAYLOAD.sort_order);
  };

  const handleRefreshURL = async () => {
    const dashboardFilters = await getDashboardFilterFromLocalStorage();

    if (dashboardFilters) {
      history.replace(`${location.pathname}?${dashboardFilters}`);
      addDashboardFilterLocalStorage(dashboardFilters);
      let consultVal = CONSULTATION_TYPE_LIST.filter(
        (data) => data.value === consultation_type
      );
      setConsultationType(consultVal[0]);
      setSelectedDate(app_start_date);
      setSortOrder(sortOrder);
      return;
    }
    addQuery(
      history,
      location,
      [
        APIFILTERLIST.CONSULTATION_TYPE,
        APIFILTERLIST.STARTDATE,
        APIFILTERLIST.SORTORDER,
      ],
      [consultation_type, app_start_date, sortOrder]
    );
    let consultVal = CONSULTATION_TYPE_LIST.filter(
      (data) => data.value === consultation_type
    );
    setConsultationType(consultVal[0]);
    setSelectedDate(app_start_date);
    setSortOrder(sortOrder);
  };

  const callApi = () => {
    setContentLoading(true);
    if (
      userType === APPLICABLE_ROLE.STAFF ||
      doctorRole === USER_ROLE.DOCTOR_ADMIN ||
      doctorRole === USER_ROLE.RESOURCE_ADMIN
    ) {
      if (clinicWithDoctor?.doctor_ids.length > 0) {
        APICall();
      }
    } else {
      APICall();
    }
  };

  const setStatusCount = (data) => {
    let list = STATUS_COUNT.filter((st) =>
      st.applicableConsultationType.includes(consultation_type.toLowerCase())
    );
    list.forEach((li) => {
      if (li.value === "total") {
        li.count = data.length;
        li.selected = selectedStatusCard === li.value;
      } else {
        li.count = data.filter(
          (da) => da.appointment_status.toLowerCase() == li.value
        ).length;
        li.selected = selectedStatusCard === li.value;
      }
    });
    setStatusCountHeader(list);
  };

  const setStatusCountQueue = (data) => {
    let list = STATUS_COUNT_QUEUE.filter((st) =>
      st.applicableConsultationType.includes(consultation_type.toLowerCase())
    );
    list.forEach((li) => {
      if (li.value === "total") {
        li.count = data.length;
        li.selected = selectedStatusCardQueue === li.value;
      } else if (!li.disabled) {
        li.count = data.filter(
          (da) => da.appointment_status.toLowerCase() == li.value
        ).length;
        li.selected = selectedStatusCardQueue === li.value;
      } else {
        li.count = "-";
      }
    });
    setStatusCountHeaderQueue(list);
  };

  const setPaymentCount = (data) => {
    let list = PAYMENT_METHOD_HEADER;
    list.forEach((li) => {
      if (li.value === "partial") {
        li.count = data.filter(
          (da) => da.partial_payment_filter === true
        ).length;
      } else if (li.value !== "all") {
        li.count = data.filter(
          (da) => da.appointment_payment_method === li.value
        ).length;
      }
      li.selected = selectedPaymentMethod === li.value;
    });
    setPaymentMethodHeader(list);
  };

  const setPaymentCountQueue = (data) => {
    let list = PAYMENT_METHOD_HEADER;
    list.forEach((li) => {
      if (li.value === "partial") {
        li.count = data.filter(
          (da) => da.partial_payment_filter === true
        ).length;
      } else if (li.value !== "all") {
        li.count = data.filter(
          (da) => da.appointment_payment_method === li.value
        ).length;
      }
      li.selected = selectedPaymentMethodQueue === li.value;
    });
    setPaymentMethodHeaderQueue(list);
  };

  const clearAllFilters = () => {
    handleRefreshURL();
  };

  const displaySelectedFilters = async () => {
    let arr = [];
    let params = await getDashboardFilterFromLocalStorage();
    if (params) {
      let params_arr = params?.split("&");
      params_arr.forEach((pa) => {
        let param = pa?.split("=")[0];
        if (param === APIFILTERLIST.DOCTOR_NAME) {
          arr.push({
            id: APIFILTERLIST.DOCTORNAME,
            label:
              SELECTEDFILTERTITLE.DOCTORNAME +
              ": " +
              decodeURIComponent(pa?.split("=")[1].replace(/[+]/g, " ")),
          });
        } else if (param === APIFILTERLIST.CONSULTATION) {
          arr.push({
            id: APIFILTERLIST.CONSULTATION,
            label:
              SELECTEDFILTERTITLE.CONSULTATION +
              ": " +
              decodeURIComponent(pa?.split("=")[1].replace(/[+]/g, " ")),
          });
        } else if (param === APIFILTERLIST.STATUS) {
          arr.push({
            id: APIFILTERLIST.STATUS,
            label:
              SELECTEDFILTERTITLE.STATUS +
              ": " +
              decodeURIComponent(pa?.split("=")[1].replace(/[+]/g, " ")),
          });
        }
      });
    }
    setSelectedFilters(arr);
  };

  const getIds = (data, doctor_filter) => {
    let ids = null;
    let selectedId = doctor_name_filter
      ? [doctor_name_filter]
      : clinicWithDoctor?.doctor_ids;
    if (data?.doctor_ids !== "") {
      ids = data?.doctor_ids
        ? [data?.doctor_ids]
        : doctor_filter
        ? selectedId
        : clinicWithDoctor?.doctor_ids;
    } else {
      ids = clinicWithDoctor?.doctor_ids;
    }
    return ids;
  };

  const getDoctorIds = (data, doctor_filter) => {
    let doc_ids = [userId];
    let dIds = getIds(data, doctor_filter);
    if (userType === APPLICABLE_ROLE.STAFF) {
      doc_ids = dIds ? dIds : clinicWithDoctor?.doctor_ids;
    } else if (clinicId) {
      if (
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN
      ) {
        let ids =
          clinicWithDoctor?.doctor_ids?.length > 0
            ? clinicWithDoctor?.doctor_ids
            : doc_ids;
        doc_ids = dIds ? dIds : ids;
      }
    }
    return doc_ids;
  };
  const getDownloadPayload = (range) => {
    let ids = getDoctorIds(null, true);
    let status = selectedStatusCard !== "total" ? selectedStatusCard : "";
    let consultation_filter_key = consultation_filter
      ? consultation_filter
      : "";
    let consultation_type_key = consultation_type ? consultation_type : "";

    let payload = {
      version: 1,
      payment_method_filter:
        selectedPaymentMethod === "cash" ? "by-cash" : selectedPaymentMethod,
      search_string: search_string ? search_string : "", // search_string
      sort_order: sort_order ? sort_order : "", // sort_order
      appointment_filter: status_filter
        ? getStatusForParamsFromUrl(status_filter)
        : getStatusForParamsFromUrl(status), // status_filter
      consultation_filter: is_procedure
        ? is_procedure === "false"
          ? getStatusForParamsFromUrl(consultation_filter_key)
          : getStatusForParamsFromUrl(consultation_type_key)
        : getStatusForParamsFromUrl(consultation_type_key),
      // it is default then it will go here
      procedure_type_filter:
        is_procedure && is_procedure === "true" ? consultation_filter_key : "", // it is not default then only it will got inside this
      start_date: moment(range.startDate).format("YYYY-MM-DD"), // range start
      end_date: moment(range.endDate).format("YYYY-MM-DD"), // range end
      doctor_ids:
        viewType === DASHBOARD_VIEW.QUEUE ? [selectedQueueDoctor] : ids, //
      download: true,
      is_all_data: true,
      clinic_id: clinicId,
      staff_id: userType === USER_TYPE.STAFF ? staffId : "",
      prescription_filter: getActivePrescriptionFilter(),
      queue_view: viewType === DASHBOARD_VIEW.QUEUE,
    };

    if (viewType === DASHBOARD_VIEW.QUEUE) {
      payload.sort_order = "";
      payload.consultation_filter = "";
      payload.procedure_type_filter = "";
      payload.prescription_filter = "";
      payload.appointment_filter =
        selectedStatusCardQueue !== "total"
          ? getStatusForParamsFromUrl(selectedStatusCardQueue)
          : "";
    }

    return payload;
  };

  const handleDefaultStatusAndPaymentCount = () => {
    //function to set status count and payment count to 0 on clinic change to avoid showing previous selected clinic count
    let list = STATUS_COUNT;
    list.forEach((da) => {
      da.count = 0;
    });
    let payment_list = PAYMENT_METHOD_HEADER;
    payment_list.forEach((li) => {
      li.count = 0;
    });
    setStatusCountHeader(list);
    setPaymentMethodHeader([...payment_list]);
  };
  // <===

  // API calls ===>

  const APICall = async (data) => {
    let doc_ids = getDoctorIds(data, false);
    let dashboardFilters = getDashboardFilterFromLocalStorage();
    let urlData = {};
    if (dashboardFilters) {
      urlData = JSON.parse(
        '{"' +
          dashboardFilters
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
    }
    let start_date =
      urlData?.start_date ?? DEFAULT_DASHBOARD_PAYLOAD.start_date;

    if (!start_date || doc_ids.length === 0) {
      return;
    }

    displaySelectedFilters();
    let param_doctor_ids = [];
    if (
      clinicId &&
      (userType === APPLICABLE_ROLE.STAFF ||
        doctorRole === USER_ROLE.DOCTOR_ADMIN ||
        doctorRole === USER_ROLE.RESOURCE_ADMIN)
    ) {
      if (data?.start_date === moment().format("YYYY-MM-DD")) {
        param_doctor_ids = allClinicDoctors;
      } else {
        param_doctor_ids = doc_ids;
      }
    } else {
      param_doctor_ids = doc_ids;
    }

    let reqPayload = {
      doctor_ids: param_doctor_ids,
      clinic_id: clinicId,
      appointment_date: start_date,
      current_timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
    };
    currentRef.current = reqPayload;
    const appointmentsData = getDashboardppointmentsData(
      reqPayload,
      GET_ALL_APPOINTMENTS_API,
      token ? token : cookies?.id_token
    ); //Fetch API Data
    appointmentsData.then(async ([res, error]) => {
      if (currentRef.current === reqPayload) {
        if (!error) {
          setLastSync(res?.current_timestamp);
          let dbData = {
            clinic_id: clinicId ? clinicId : "default",
          };
          let tempDbData = await dexie_db.appointment.get(
            clinicId ? clinicId : "default"
          );
          let currentDate = moment().format("YYYY-MM-DD");
          if (tempDbData?.hasOwnProperty(currentDate)) {
            dbData[currentDate] = tempDbData[currentDate];
          }
          if (res?.appointments?.length > 0) {
            let object = res?.appointments?.reduce(
              (obj, item) =>
                Object.assign(obj, { [item.appointment_id]: item }),
              {}
            );
            dbData[start_date] = {
              last_sync: res?.current_timestamp,
              data: object,
            };
            dexie_db.appointment.put(dbData);
          } else {
            dbData[start_date] = {
              last_sync: res?.current_timestamp,
              data: [],
            };
            dexie_db.appointment.put(dbData);
          }
        }
        setTimeout(() => {
          setContentLoading(false);
        }, 800);
      }
    });
    if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
      if (start_date === moment().format("YYYY-MM-DD")) {
        let payload = {
          doctor_ids: doc_ids,
          clinic_id: clinicId,
        };
        getCheckedInApi(payload);
      }
    }
  };

  const getCheckedInApi = (reqPayload) => {
    const resData = c2cPostApiHandler(
      GET_CHECKED_IN_APPOINTMENT_API,
      reqPayload
    );
    resData.then(([res, error]) => {
      if (!error) {
        if (res?.data?.statusCode === 200) {
          setCheckedInAppnt(res?.data?.checked_in_appt_doctor_ids);
        }
      }
    });
  };

  const getProcedures = (doctorIdsArr) => {
    let payload = {
      clinic_id: clinicId,
      doctor_name_filter,
      doctor_selected: doctorIdsArr ?? clinicWithDoctor?.doctor_ids,
      user_id: userId ? userId : cookies?.user_id,
      doctorRole,
      user_type: userType,
      token: token ? token : cookies?.id_token,
    };
    const consultationTypeResponse = getProcedureAPIPayload(payload, token);
    consultationTypeResponse.then(([res, error]) => {
      if (!error) {
        setProcedures(res);
      } else {
        setProcedures([]);
      }
    });
  };

  const getActivePrescriptionFilter = () => {
    let prescription_filter = new URLSearchParams(location.search).get(
      APIFILTERLIST.PRESCRIPTION_FILTER
    );
    return prescription_filter === "" ? "not_created" : prescription_filter;
  };
  const makeDownloadAPICall = (range) => {
    setContentLoading(true);
    const params = {
      report_type: "appointment",
      user_type: userType,
      payload: getDownloadPayload(range),
    };
    const resData = c2cPostApiHandler(DOWNLOAD_TRANSACTIONS_REPORT_API, params);
    resData.then(([res, err]) => {
      if (!err) {
        if (res && res.data.message === "request published successfully") {
          downloadRef.current.showDownloadReport();
          localStorage.setItem("DownloadReport", "true");
          localStorage.setItem("AppntDisableDownload", "true");
          setDisableDownload(true);
          let arr = [];
          arr = localStorage.getItem("DownloadReportArr")
            ? JSON.parse(localStorage.getItem("DownloadReportArr"))
            : [];
          arr.push({
            id: res.data.request_id,
            filename: res.data.filename,
            requestType: "appointment",
            pause: false,
          });
          localStorage.setItem("DownloadReportArr", JSON.stringify(arr));
          setDownloadReport(arr);
        }
        setContentLoading(false);
      } else {
        setContentLoading(false);
      }
    });
  };

  const removeQueueData = () => {
    localStorage.setItem("dashboardView", DASHBOARD_VIEW.LIST);
    localStorage.removeItem("lsSelectedQueueDoctor");
    localStorage.removeItem("lsSelectedQueueDoctorList");
    setViewType(DASHBOARD_VIEW.LIST);
    setSocketResponse(false);
  };
  // Actions ===>

  const onPageChange = async (val) => {
    const dashboardFilters = await getDashboardFilterFromLocalStorage();
    if (dashboardFilters) {
      let urlData = JSON.parse(
        '{"' +
          dashboardFilters
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
      addQuery(
        history,
        window.location,
        [
          APIFILTERLIST.CONSULTATION_TYPE,
          APIFILTERLIST.STARTDATE,
          APIFILTERLIST.SORTORDER,
          APIFILTERLIST.PAGENO,
        ],
        [urlData.consultation_type, app_start_date, sortOrder, val]
      );
    } else {
      addQuery(
        history,
        window.location,
        [
          APIFILTERLIST.CONSULTATION_TYPE,
          APIFILTERLIST.STARTDATE,
          APIFILTERLIST.SORTORDER,
          APIFILTERLIST.PAGENO,
        ],
        [consultation_type, app_start_date, sortOrder, val]
      );
    }
  };

  const toggleFilterMenu = () => {
    setShowMobileFilter(true);
  };

  const toggleDownloadFilterMenu = () => {
    setShowDownloadMobileFilter(true);
  };
  const toggleFilterMenuQueue = () => {
    setShowMobileFilterQueue(true);
  };

  const handleCloseMobileFilter = () => {
    setShowMobileFilter(false);
    setShowDownloadMobileFilter(false);
  };

  const handleCloseMobileFilterQueue = () => {
    setShowMobileFilterQueue(false);
  };

  const handleConsultationType = (value) => {
    if (value?.value !== consultation_type) {
      setConsultationType(value);
      removeDashboardFilterFromLocalStorage();
      history.push({
        pathname: location.pathname,
        search: `?${APIFILTERLIST.CONSULTATION_TYPE}=${value.value}&${APIFILTERLIST.STARTDATE}=${app_start_date}&${APIFILTERLIST.SORTORDER}=${sortOrder}`,
      });
    }
  };

  const handleStatusCard = (val, clicked) => {
    setSelectedStatusCard(val);
    if (val !== selectedStatusCard && clicked) {
      onPageChange(1);
    }

    statusCountHeader.forEach((st) => {
      st.selected = false;
      if (st.value === val) {
        st.selected = true;
      }
    });
    setStatusCountHeader([...statusCountHeader]);
  };

  const handleStatusCardQueue = (val, clicked) => {
    if (
      val !== QUEUE_STATUS.COMPLETED &&
      val !== QUEUE_STATUS.CANCELLED &&
      val !== QUEUE_STATUS.NO_SHOW
    ) {
      if (val !== selectedStatusCardQueue && clicked) {
        onPageChange(1);
      }

      setSelectedStatusCardQueue(val);
      statusCountHeaderQueue.forEach((st) => {
        st.selected = false;
        if (st.value === val) {
          st.selected = true;
        }
      });
      setStatusCountHeaderQueue([...statusCountHeaderQueue]);
    }
  };

  const handlePaymentMethod = (data, clicked) => {
    setSelectedPaymentMethod(data.value);
    paymentMethodHeader.forEach((st) => {
      st.selected = false;
      if (st.value === data.value) {
        st.selected = true;
      }
    });
    setPaymentMethodHeader([...paymentMethodHeader]);
    if (clicked) {
      let key = [APIFILTERLIST.PAGENO];
      let value = [DEFAULT_DASHBOARD_PAYLOAD.page_no];
      addQuery(history, location, key, value);
    }
  };

  const handlePaymentMethodQueue = (data, clicked) => {
    setSelectedPaymentMethodQueue(data.value);
    paymentMethodHeaderQueue.forEach((st) => {
      st.selected = false;
      if (st.value === data.value) {
        st.selected = true;
      }
    });
    setPaymentMethodHeaderQueue([...paymentMethodHeaderQueue]);
    if (clicked) {
      let key = [APIFILTERLIST.PAGENO];
      let value = [DEFAULT_DASHBOARD_PAYLOAD.page_no];
      addQuery(history, location, key, value);
    }
  };

  const handleSortOrder = (val) => {
    setSortOrder(val);
  };

  const handleRefreshedData = (id) => {
    setOngoingRequest(true);
    localStorage.setItem(LOCALSTORAGEKEY.PENDING_REQUEST, false);
    let doc_ids = getDoctorIds(null, false);
    if (doc_ids?.length <= 0) {
      return;
    }
    let urlData = {};
    const dashboardFilters = getDashboardFilterFromLocalStorage();
    if (dashboardFilters) {
      urlData = JSON.parse(
        '{"' +
          dashboardFilters
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
    }
    let start_date =
      urlData?.start_date ?? DEFAULT_DASHBOARD_PAYLOAD.start_date;
    dexie_db.appointment
      .where("clinic_id")
      .equals(clinicId ? clinicId : "default")
      .toArray(function (app) {
        if (app?.length > 0) {
          let payload = {
            doctor_ids: doc_ids,
            clinic_id: clinicId,
            timestamp: app[0][start_date]?.last_sync,
            current_timestamp: moment().format("YYYY-MM-DD HH:mm:ss"),
          };

          const refreshedappointmentsData = getRefreshedAppointmentData(
            payload,
            logger
          );
          refreshedappointmentsData.then(async ([res, error]) => {
            if (!error) {
              if (res?.current_timestamp) {
                setLastSync(res?.current_timestamp);
                let dbData = {
                  clinic_id: clinicId ? clinicId : "default",
                };
                let tempDbData = await dexie_db.appointment.get(
                  clinicId ? clinicId : "default"
                );
                let appntData = {};
                let currentDate = moment().format("YYYY-MM-DD");
                if (tempDbData?.hasOwnProperty(currentDate)) {
                  dbData[currentDate] = { ...tempDbData[currentDate] };
                  appntData = { ...tempDbData[currentDate]?.data };
                }
                if (res?.appointments_to_remove?.length > 0) {
                  res.appointments_to_remove.forEach((appointment_id) => {
                    delete appntData[appointment_id];
                  });
                }

                if (res?.appointments?.length > 0) {
                  let filteredRes = res?.appointments?.filter(
                    (data) => data.appointment_date === start_date
                  );
                  // condition to check and update the db
                  if (filteredRes?.length > 0) {
                    filteredRes.forEach((appnt) => {
                      appntData[appnt.appointment_id] = appnt;
                    });
                    dbData = {
                      ...dbData,
                      [currentDate]: {
                        data: {
                          ...appntData,
                        },
                      },
                    };
                  }
                  dbData[start_date] = {
                    ...dbData[currentDate],
                    last_sync: res?.current_timestamp,
                  };
                } else {
                  dbData = {
                    ...dbData,
                    [currentDate]: {
                      data: {
                        ...appntData,
                      },
                      last_sync: res?.current_timestamp,
                    },
                  };
                }
                dexie_db.appointment.put(dbData);
              }
            }
            setOngoingRequest(false);
            if (
              localStorage.getItem(LOCALSTORAGEKEY.PENDING_REQUEST) === true
            ) {
              checkBeforeInvokeRefreshAPI(res?.current_timestamp);
            }
          });
        }
      });
    if (consultation_type === CONSULTATIONTYPE.INCLINIC) {
      if (start_date === moment().format("YYYY-MM-DD")) {
        let payload = {
          doctor_ids: doc_ids,
          clinic_id: clinicId,
        };
        getCheckedInApi(payload);
      }
    }
  };

  const invokeRefreshAPI = () => {
    timeoutRef.current = false;
    if (ongoingRequest === false) {
      handleRefreshedData();
    } else {
      localStorage.setItem(LOCALSTORAGEKEY.PENDING_REQUEST, true);
    }
  };

  const checkBeforeInvokeRefreshAPI = (lastSyncPara) => {
    const elapsed_duration = calculateTimeDifferenceInSeconds(
      lastSyncPara,
      moment().format("YYYY-MM-DD HH:mm:ss")
    );
    if (elapsed_duration > POLLING_DURATION_FOR_REFRESH_API) {
      invokeRefreshAPI();
    } else {
      const tempDur = POLLING_DURATION_FOR_REFRESH_API - elapsed_duration;
      setTimeout(invokeRefreshAPI, [tempDur * 1000]);
    }
  };

  const calculateTimeDifferenceInSeconds = (startTime, endTime) => {
    const start = moment(startTime, "YYYY-MM-DD HH:mm:ss");
    const end = moment(endTime, "YYYY-MM-DD HH:mm:ss");
    return end.diff(start, "seconds");
  };

  const onRescheduleAppnt = (id) => {
    if (app_start_date === moment().format("YYYY-MM-DD")) {
      handleRefreshedData(id);
    } else {
      APICall();
    }
  };

  const handlePageRefresh = async (lastSyncPara) => {
    let dashboardFilters = getDashboardFilterFromLocalStorage();
    let urlData = {};
    if (dashboardFilters) {
      urlData = JSON.parse(
        '{"' +
          dashboardFilters
            .replace(/"/g, '\\"')
            .replace(/&/g, '","')
            .replace(/=/g, '":"') +
          '"}'
      );
    }

    let start_date =
      urlData?.start_date ?? DEFAULT_DASHBOARD_PAYLOAD.start_date;

    if (start_date === moment().format("YYYY-MM-DD")) {
      if (!timeoutRef.current) {
        timeoutRef.current = true;
        checkBeforeInvokeRefreshAPI(lastSyncPara);
      }
    } else {
      APICall();
    }
  };

  const downloadCallback = (range) => {
    makeDownloadAPICall(range);
  };

  const handleDisableDownload = () => {
    setDisableDownload(false);
  };

  const selectQueueDoctor = (doct_id) => {
    setSelectedQueueDoctor(doct_id);
  };

  const handleButtonGroup = (name) => {
    setSocketResponse(false);
    if (name !== viewType) {
      selectQueueDoctor("");
      if (name === DASHBOARD_VIEW.LIST) {
        localStorage.setItem("dashboardView", DASHBOARD_VIEW.LIST);
        setViewType(DASHBOARD_VIEW.LIST);
      } else {
        setViewType(name);
        if (
          doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
          doctorRole !== USER_ROLE.RESOURCE_CONSULTANT
        ) {
          if (showedQueueViewSuggestion !== "true") {
            setShowJoyride(true);
          }
          localStorage.setItem("showedQueueSuggestion", true);
        }
        if (
          doctorRole !== USER_ROLE.DOCTOR_CONSULTANT &&
          doctorRole !== USER_ROLE.RESOURCE_CONSULTANT
        ) {
          localStorage.setItem("showedQueueSuggestion", true);
        }
        localStorage.setItem("dashboardView", name);
        let list = STATUS_COUNT_QUEUE;
        list.forEach((da) => {
          if (!da?.disabled) {
            da.count = 0;
          } else {
            da.count = "-";
          }
        });
        let payment_list = PAYMENT_METHOD_HEADER;
        payment_list.forEach((li) => {
          li.count = 0;
        });
        setPaymentMethodHeaderQueue(payment_list);
        setStatusCountHeaderQueue(list);
      }
      onPageChange(1);
    }
  };

  const handleCloseJoyRide = (action) => {
    C2CConsole.log(action);
  };

  // on click on refresh button call appointments api
  const handleAllAppointmentsData = () => {
    APICall({
      [APIFILTERLIST.STARTDATE]: selectedDate,
      [APIFILTERLIST.PAGENO]: 1,
    });
  };

  const getClinicUhidDetailsAPICall = () => {
    const uhIdResponse = c2cGetApiHandler(GET_UHID_LIST(clinicId));
    uhIdResponse.then(([res, error]) => {
      if (!error && res?.data?.statusCode === 200) {
        setIsUhidEnabled(res?.data?.patient_uhid_enabled);
      } else {
        setIsUhidEnabled(false);
      }
    });
  };

  // <===

  // Create UI ==>
  const renderDashboardAppointmentsHeader = () => {
    return (
      <DashboardAppointmentsViewHeader
        user_type={userType}
        clinic_id={clinicId}
        sort_order={sort_order}
        consultation_type={selected_consultation_type}
        selectedDate={selectedDate}
        disableDownload={disableDownload}
        defaultDate={app_start_date}
        search_string={search_string}
        clinicDropDownStatus={clinicDropDownStatus}
        toggleFilterMenu={toggleFilterMenu}
        toggleDownloadFilterMenu={toggleDownloadFilterMenu}
        handleConsultationType={handleConsultationType}
        handleSortOrder={handleSortOrder}
        handleRefreshedData={() => {
          app_start_date !== CURRENT_DATE && handleAllAppointmentsData();
        }}
        downloadCallback={downloadCallback}
        viewType={viewType}
        callDashboardAppointmentsApi={() => {
          app_start_date !== CURRENT_DATE && APICall();
        }}
        handleButtonGroup={handleButtonGroup}
        toggleFilterMenuQueue={toggleFilterMenuQueue}
        hasDownloadPermission={hasDownloadPermission}
      />
    );
  };

  const renderDashboardAppointmentsMainContent = () => {
    return (
      <DashboardAppointmentsViewTable
        user_type={userType}
        doctorRole={doctorRole}
        user_id={userId}
        clinic_id={clinicId}
        staff_id={staffId}
        page_no={page_no}
        dashboardAppointmentsData={appointmentList}
        selectedFilters={selectedFilters}
        consultation_type={consultation_type}
        consultation_filter={consultation_filter}
        status_filter={status_filter}
        doctor_name_filter={doctor_name_filter}
        contentLoading={contentLoading}
        selected_doctor={selected_doctor}
        showMobileFilter={showMobileFilter}
        showDownloadMobileFilter={showDownloadMobileFilter}
        statusCountHeader={statusCountHeader}
        selectedStatusCard={selectedStatusCard}
        paymentMethodHeader={paymentMethodHeader}
        doctorClinicAssociation={doctorClinicAssociation}
        app_start_date={app_start_date}
        procedures={procedures}
        consultationWiseDoctors={consultationWiseDoctors}
        checkedInAppnt={checkedInAppnt}
        socketResponse={socketResponse}
        handleRefreshApi={() => {}} //handlePageRefresh
        handleCloseMobileFilter={handleCloseMobileFilter}
        handleStatusCard={(data) => handleStatusCard(data, true)}
        handlePaymentMethod={(data) => handlePaymentMethod(data, true)}
        onRescheduleAppnt={() => {
          app_start_date !== CURRENT_DATE && onRescheduleAppnt();
        }}
        callNextAppointmentWidget={callNextAppointmentWidget}
        callDashboardAppointmentsApi={() => {
          app_start_date !== CURRENT_DATE && APICall();
        }}
        downloadCallback={downloadCallback}
        statusCountHeaderQueue={statusCountHeaderQueue}
        selectQueueDoctor={selectQueueDoctor}
        viewType={viewType}
        appointmentListQueueView={appointmentListQueueView}
        paymentMethodHeaderQueue={paymentMethodHeaderQueue}
        handleStatusCardQueue={(data) => handleStatusCardQueue(data, true)}
        handlePaymentMethodQueue={(data) =>
          handlePaymentMethodQueue(data, true)
        }
        showMobileFilterQueue={showMobileFilterQueue}
        handleCloseMobileFilterQueue={handleCloseMobileFilterQueue}
        isUhidEnabled={isUhidEnabled}
      />
    );
  };
  // <===

  // Renders appointmentData information & pagination inside a footer component
  const renderFooterContent = () => {
    return (
      <DashboardAppointmentsViewFooter
        dashboardAppointmentsData={appointmentList}
        currentPage={page_no}
        totalCount={appointmentList?.length}
        pageSize={Number(DEFAULT_DASHBOARD_PAYLOAD.rows_per_page)}
        onPageChange={onPageChange}
      />
    );
  };

  const renderFooterContentQueue = () => {
    return (
      <DashboardAppointmentsViewFooter
        dashboardAppointmentsData={appointmentListQueueView}
        currentPage={page_no}
        totalCount={appointmentListQueueView?.length}
        pageSize={Number(DEFAULT_DASHBOARD_PAYLOAD.rows_per_page)}
        onPageChange={onPageChange}
      />
    );
  };
  // <===

  return (
    <>
      {renderDashboardAppointmentsHeader()}
      {renderDashboardAppointmentsMainContent()}
      {viewType === DASHBOARD_VIEW.LIST && renderFooterContent()}
      {viewType === DASHBOARD_VIEW.QUEUE && renderFooterContentQueue()}
      <DownloadReport
        ref={downloadRef}
        handleAppntDisableDownload={handleDisableDownload}
        downloadReport={downloadReport}
      />
      <DoctorListJoyRides
        steps={stepsData.doctor["Home"]}
        callback={handleCloseJoyRide}
        run={showJoyride}
      />
    </>
  );
};

export default DashboardAppointmentsView;
